<template>
  <div class="home" ref="home" :class="{ 'createHome': createLoad }" :style="'height:' + screenHeight + 'px'">
    <div @touchstart="hideTypes">
      <div class="navBar norem_navBar" ref="navBar">
        <div class="navBar_left" v-if="!createLoad && !createSuccess" @click="goBack">返回</div>
        <div class="navBar_left" v-else-if="createSuccess" @click="goCancelCreate">返回</div>
        <div class="navBar_center" v-show="!isCreate">
          <div class="undo c_btn" @click="undoDraw()" :class="{ btnActive: !undoDisabled }">
            <img class="c_btn_img" src="../assets/img/undo.png" alt />
          </div>
          <div class="redo c_btn" @click="redoDraw()" :class="{ btnActive: !redoDisabled }">
            <img class="c_btn_img" src="../assets/img/undo.png" alt />
          </div>
        </div>
        <div class="navBar_right" @click="goClear" :class="{ btnActive: !undoDisabled }" v-show="!isCreate">重置</div>
      </div>
      <div class="content" ref="content" :class="{ 'content1': createSuccess }">
        <div class="hide">
          <div class="successImg" ref="successImg" v-show="createSuccess && isCreate"
            :style="'aspect-ratio:' + canvasRatio">
            <img class="imgSize" :src="successImg" alt />
          </div>
          <div v-show="!createSuccess" class="canvasBg" :class="{ canvasBlur: createLoad }"
            :style="'background-image:url(' + imgUrl + ')'">
            <canvas id="myCanvas" :style="'border-width:' + (imgUrl ? '1px' : 0)" ref="myCanvas"></canvas>
          </div>
        </div>
        <div class="create" v-if="createLoad" :style="'aspect-ratio:' + canvasRatio">
          <div>
            <div class="create_loading">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </div>
            <div class="create_text">AI 生图中</div>
          </div>
        </div>
      </div>
      <div class="footWrap" ref="myFoot">
        <div class="createFoot" v-if="isCreate">
          <div class="cancelBtn" @click="cancelCreate" v-if="createLoad">取消生成</div>
          <div class="btns" v-else-if="createSuccess">
            <div class="btn btn1" @click="regeneration">
              <img src="../assets/img/cxsc.png" alt />
              <div>重新生成</div>
            </div>
            <div class="btn btn2 btn3" v-show="saveLoad">
              <img src="../assets/img/btnLoading.png" alt />
              <div>保存中</div>
            </div>
            <div class="btn btn2" @click="saveImg" v-show="!saveLoad">
              <img src="../assets/img/xz.png" alt />
              <div>保存相册</div>
            </div>
          </div>
        </div>
        <div class="foot" v-else>
          <div class="createImgAI" :class="{ menuRightDisable: history.length < 1 }" @click="createImg">
            <img src="../assets/img/shengtu.png" alt />
          </div>
          <div class="menu">
            <div class="menu_center" @touchstart.stop>
              <div class="c_btn" @click="changeAction(1)" :class="{ btnActive: menuActive == 1 }">
                <img src="../assets/img/hua.png" alt />
                <div>绘画</div>
              </div>
              <div class="c_btn" @click="changeAction(2)" :class="{ btnActive: menuActive == 2 }">
                <img src="../assets/img/ca.png" alt />
                <div>橡皮</div>
              </div>
              <div class="c_btn" @click="changeAction(3)" :class="{ btnActive: menuActive == 3 }">
                <img src="../assets/img/wen.png" alt />
                <div>模版</div>
              </div>
            </div>
          </div>
          <div class="painting types" v-show="menuShow == 1" @touchstart.stop>
            <div class="widths yuan" v-for="(item, index) in widthArr" :key="index"
              :class="(index == lineActive ? 'active' : '')" @click="changeWidth(index, item, 'draw')">
              <div></div>
            </div>
            <div class="t_xain"></div>
            <div class="colors yuan" v-for="(item, index) in colorArr" :key="item" :style="'background-color:' + item"
              :class="(index == colorActive ? 'active' : '')" @click="changeColor(index, item)">
              <img src="../assets/img/select.png" alt />
            </div>
          </div>
          <div class="eraser types" v-show="menuShow == 2" @touchstart.stop>
            <div class="widths yuan" v-for="(item, index) in widthArr" :key="index"
              :class="(index == eraseActive ? 'active' : '')" @click="changeWidth(index, item, 'erase')">
              <div></div>
            </div>
          </div>
          <div class="iconWrap types" v-show="menuShow == 3" ref="iconWrap" @touchstart.stop>
            <div class="iconMask before" v-show="leftMaskShow">
              <img class="imgSize" src="../assets/img/listMask.png" alt />
            </div>
            <div class="iconMask after" v-show="!rightMaskShow">
              <img class="imgSize" src="../assets/img/listMask.png" alt />
            </div>
            <div class="iconList" @scroll="handleScroll" ref="iconList">
              <div class="iconItem" :class="{ iconActive: iconIndex == index }" v-for="(item, index) in iconList"
                :key="index" @click="changeIconActive(item, index)">
                <img :src="item" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <myAlert v-if="resetShow" title="重置" text="重置后不可恢复，确定需要重置现在的创作吗" confirmText="确认重置" @cancel="resetShow = false"
      @confirm="clear"></myAlert>
    <myAlert v-if="deleteShow" title="替换模版" text="每次只能使用一个模板，确认替换为新模板吗" confirmText="确认替换" @cancel="deleteShow = false"
      @confirm="deleteIcon"></myAlert>
    <myAlert v-if="backShow" title="退出AI创作" text="退出后不可恢复，确定需要离开当前的创作吗" @cancel="backShow = false"
      @confirm="backConfirm"></myAlert>
  </div>
</template>

<script>
import myAlert from "@/components/myAlert/myAlert.vue";
import { EventBus } from "@/utils/eventBus.js";
import Gio from "@/utils/gio";
import {
  uploadImgs,
  genResult,
  newGraffiti,
  saveGraffiti
} from "@/api/createImg";
import { imageToBase64 } from "@/utils/imageToBase64";
import dsBridge from "dsbridge";
import themeColorData from "@/utils/ColorUtil";
import { CanvasDraw } from "@/utils/canvasDraw";
import store from "@/store";
export default {
  name: "HomeView",
  components: {
    myAlert
  },
  data() {
    return {
      screenHeight: document.documentElement.clientHeight,
      screenWidth: document.documentElement.clientWidth,
      nowtTime: new Date().getTime(),
      vin: "",
      imgUrl: "",
      canvasRatio: 16 / 9,
      menuActive: 1,
      menuShow: -1,
      activeColor: "",

      widthArr: [],
      lineActive: 0,
      eraseActive: 0,
      colorArr: [],
      colorActive: 0,

      myCanvas: null,

      iconList: [],
      iconIndex: -1,
      selectIconIndex: -1,
      canvasOldHeight: 0,

      resetShow: false,
      isCreate: false,
      createLoad: false,
      createSuccess: false,
      saveLoad: false,
      successImg: "",
      successImgUrl: "",
      timer: null,
      imgData: {},

      deleteShow: false,

      themeColor: "black",
      saveImgdata: null,
      backShow: false,
      leftMaskShow: false,
      rightMaskShow: false,
      isBackClick: false
    };
  },
  created() {
    try {
      Gio.init();
    } catch (error) {
      console.log('create-gio-init', error);
    }
    this.initData();
    var list = [];
    for (var i = 0; i < 20; i++) {
      list.push(require("@/assets/icon/" + (i + 1) + ".png"));
    }
    this.iconList = list;
    EventBus.$on("changeIconActive", iconIndex => {
      this.iconIndex = iconIndex;
    });
  },
  mounted() {
    this.myCanvas = new CanvasDraw("myCanvas");
    this.widthArr = this.myCanvas.widthArr;
    this.colorArr = this.myCanvas.colorArr;
    this.activeColor = this.myCanvas.activeColor;
  },
  computed: {
    colorData() {
      return themeColorData[this.themeColor];
    },
    history() {
      return this.myCanvas ? this.myCanvas.history : [];
    },
    undoDisabled() {
      return this.myCanvas ? !this.myCanvas.undoHistory.length : true;
    },
    redoDisabled() {
      return this.myCanvas ? !this.myCanvas.redoHistory.length : true;
    }
  },
  watch: {
    isCreate: {
      handler() {
        this.resetCanvasSizeBefore();
      },
      immediate: true
    }
  },
  methods: {
    changeWidth(index, item, type) {
      if (type == "draw") {
        this.lineActive = index;
      } else {
        this.eraseActive = index;
      }
      this.myCanvas.changeWidth(index, item, type);
    },
    changeColor(index, item) {
      this.colorActive = index;
      this.myCanvas.changeColor(item);
    },
    changeIconActive(item, index) {
      if (this.iconIndex == index) return;
      this.myCanvas.changeIconActive(item, index, show => {
        this.deleteShow = show;
      });
    },
    changeAction(type) {
      if (
        (type == 3 && this.menuShow === 3) ||
        (type != 3 && this.menuShow == type)
      )
        return;
      this.menuShow = type;
      this.menuActive = type;
      this.myCanvas.changeAction(type);
      Gio.track({
        ClickButton_var: type == 1 ? "绘画" : type == 2 ? "橡皮" : "模板"
      });
    },
    undoDraw() {
      this.myCanvas.undoDraw();
    },
    redoDraw() {
      this.myCanvas.redoDraw();
    },
    async createImg() {
      if (this.history.length < 1 || this.createLoad) return;
      this.isCreate = true;
      this.createLoad = true;
      this.successImg = "";
      this.successImgUrl = "";
      var drawSize = this.myCanvas.getDrawSize();
      if (drawSize.isCompletelyErased) {
        this.isCreate = false;
        this.createLoad = false;
        // this.$Message.message("绘画已被橡皮擦清空，请重新绘制或回退!");
        this.$Message.message("绘画已被清空，请重新绘制或回退!");
        return;
      }
      try {
        let img = await this.getScreenshot(drawSize, this.myCanvas.toDataURL());
        this.uploadImgs([
          {
            order: 1,
            imageBase: img
          }
        ]);
      } catch (err) {
        console.log("createImg-err", err);
        this.isCreate = false;
        this.createLoad = false;
      }
      Gio.track({
        ClickButton_var: "AI生图"
      });
    },

    uploadImgs(imageList) {
      console.time("上传图片时间");
      uploadImgs({
        imageList
      })
        .then(res => {
          console.timeEnd("上传图片时间");
          console.log("uploadImgs-res", res);
          var data = {
            vin: this.vin,
            sid: "",
            graffitiImgUrl: res.data && res.data[0].imageUrl
          };
          this.imgData = data;
          this.newGraffiti();
        })
        .catch(() => {
          this.isCreate = false;
          this.createLoad = false;
        });
    },
    newGraffiti() {
      console.time("获取jobId时间");
      newGraffiti(this.imgData)
        .then(res => {
          console.timeEnd("获取jobId时间");
          console.time("生图时间");
          this.genResult(res.data.jobId);
        })
        .catch(() => {
          this.isCreate = false;
          this.createLoad = false;
        });
    },
    genResult(jobId) {
      genResult({ jobId })
        .then(res => {
          console.log("genResult", res);
          if (!this.createLoad) return;
          if (res.data.status == "PROCESSING") {
            this.timer = setTimeout(() => {
              this.genResult(jobId);
            }, 1000);
          } else if (res.data.status == "FINISHED") {
            this.setSuccessImg(res.data.content.split(",")[0], jobId);

            console.timeEnd("生图时间");
          } else {
            this.$Message.message(res.data.content);
            clearTimeout(this.timer);
            this.isCreate = false;
            this.createLoad = false;
            this.createSuccess = false;
          }
        })
        .catch(() => {
          this.isCreate = false;
          this.createLoad = false;
        });
    },

    setSuccessImg(url, jobId) {
      var tempCanvas = document.createElement("canvas");
      var canvasData = this.myCanvas.getCanvasObj();
      var drawSize = this.myCanvas.getDrawSize();
      tempCanvas.width = canvasData.width;
      tempCanvas.height = canvasData.height;

      var tempCtx = tempCanvas.getContext("2d");
      let boxImg = new Image();
      boxImg.src = this.imgUrl;
      boxImg.onload = () => {
        tempCtx.drawImage(boxImg, 0, 0, canvasData.width, canvasData.height);
      };

      imageToBase64(url)
        .then(base64Image => {
          let img = new Image();
          img.src = base64Image;
          img.onload = () => {
            console.log("drawSize", drawSize);
            tempCtx.drawImage(
              img,
              drawSize.left,
              drawSize.top,
              drawSize.width,
              drawSize.height
            );

            let aiImg = new Image();
            aiImg.src = require("@/assets/img/ai.png");
            aiImg.onload = () => {
              tempCtx.drawImage(
                aiImg,
                canvasData.width - 65,
                canvasData.height - 35,
                49,
                32
              );
              this.successImg = tempCanvas.toDataURL("image/jpg", 1);
              this.successImgUrl = this.successImg;
              this.createLoad = false;
              this.createSuccess = true;
              this.saveImgdata = null;
              this.resetCanvasSizeBefore();
              this.saveGraffiti(jobId);
            };
          };
        })
        .catch(err => {
          console.log("saveImg-imageToBase64", err);
          this.$Message.message("图片格式转换失败，请重试!");
          this.isCreate = false;
          this.createLoad = false;
        });
    },
    saveGraffiti(jobId) {
      uploadImgs({
        imageList: [
          {
            order: 2,
            imageBase: this.successImg.split(",")[1]
          }
        ]
      }).then(res => {
        console.log("uploadImgs-res", res);
        var resultUrl = res.data && res.data[0].imageUrl;
        saveGraffiti({
          jobId,
          resultUrl,
          graffitiImgUrl: this.imgData.graffitiImgUrl,
          vin: this.vin
        });
      });
    },
    getScreenshot(data, dataURL) {
      var { left, top, width, height } = data;
      return new Promise(resolve => {
        // 创建一个新的画布，大小等于截图区域的大小
        var tempCanvas = document.createElement("canvas");
        tempCanvas.width = width;
        tempCanvas.height = height;
        var tempCtx = tempCanvas.getContext("2d");
        // 设置背景颜色为黑色
        // tempCtx.fillStyle = "#000000"; // 或者使用 "black"
        tempCtx.fillRect(0, 0, width, height);
        var img = new Image();
        img.src = dataURL;
        // 将截图区域绘制到临时画布
        img.onload = () => {
          console.log("img.onload", img.width, img.height);
          // 绘制图片到canvas, 位置为(0, 0)，大小为图片本身大小
          tempCtx.drawImage(img, -left, -top, img.width, img.height);

          var imgUrl = tempCanvas.toDataURL("image/jpg", 1);
          resolve(imgUrl.split(",")[1]);
        };
      });
    },
    saveImg() {
      this.saveLoad = true;
      if (this.saveImgdata) {
        this.savePicture();
      } else {
        this.saveImgdata = {
          file: this.successImg.split(",")[1]
        };
        this.savePicture();
      }
      Gio.track({
        ClickButton_var: "保存相册"
      });
    },
    savePicture() {
      dsBridge.call("savePicture", this.saveImgdata, res => {
        console.log("savePicture", res);
        if (res) {
          res = typeof res === "string" ? JSON.parse(res) : res;
          console.log("savePicture1", res, res.code);
          if (res.code == 200) {
            this.saveLoad = false;
            this.$Message.message("保存成功");
          } else {
            this.saveLoad = false;
            this.$Message.message("保存失败");
          }
        }
      });
    },
    goClear() {
      if (!this.history.length) return;
      this.resetShow = true;
    },
    clear() {
      this.resetShow = false;
      this.iconIndex = -1;
      this.myCanvas.clear();
      Gio.track({
        ClickButton_var: "重置"
      });
    },
    regeneration() {
      this.createLoad = true;
      this.createSuccess = false;
      this.saveImgdata = null;
      this.successImg = "";
      this.resetCanvasSizeBefore();
      this.newGraffiti();
      Gio.track({
        ClickButton_var: "重新生成"
      });
    },
    goCancelCreate() {
      clearTimeout(this.timer);
      this.isCreate = false;
      this.createLoad = false;
      this.successImg = "";
      this.successImgUrl = "";
      this.createSuccess = false;
      this.saveImgdata = null;
    },
    cancelCreate() {
      if (this.successImgUrl) {
        this.successImg = this.successImgUrl;
        this.createLoad = false;
        this.createSuccess = true;
        this.saveImgdata = null;
      } else {
        this.goCancelCreate();
      }

      Gio.track({
        ClickButton_var: "取消生成"
      });
    },

    deleteIcon() {
      this.myCanvas.deleteIcon();
      if (this.deleteShow) this.deleteShow = false;
    },
    handleScroll(event) {
      const scrollLeft = event.target.scrollLeft;
      this.leftMaskShow = scrollLeft > 60;
      var iconWrap = this.$refs.iconWrap;
      this.rightMaskShow =
        scrollLeft > 112 * this.iconList.length - 16 - iconWrap.offsetWidth;
    },

    hideTypes() {
      this.menuShow = -1;
    },
    resetCanvasSizeBefore() {
      this.$nextTick(() => {
        this.resetCanvasSize();
      });
    },
    resetCanvasSize() {
      var content = this.$refs.content;
      var successImg = null;
      if (this.successImg) {
        successImg = this.$refs.successImg;
      }
      var myFootHeight = this.isCreate ? 0 : 125;
      var navBarHeight = this.createLoad || this.createSuccess ? 0 : 72;

      let contentHeight = this.screenHeight - myFootHeight - navBarHeight;
      console.log(
        "myFootHeight",
        myFootHeight,
        "navBarHeight",
        navBarHeight,
        "this.screenHeight",
        this.screenHeight,
        "this.screenWidth",
        this.screenWidth,
        "contentHeight",
        contentHeight
      );
      content.style.height = contentHeight + "px";

      let maxWidth = this.$refs.home.offsetWidth;
      let maxHeight = maxWidth / this.canvasRatio;
      if (maxHeight > contentHeight) {
        if (!this.createSuccess) {
          this.myCanvas.setCanvasSize(
            contentHeight * this.canvasRatio,
            contentHeight
          );
        }
        if (!this.myCanvasOldHeight) this.myCanvasOldHeight = contentHeight;
        this.myCanvas.setCanvasZoom(contentHeight / this.myCanvasOldHeight);
        if (successImg) {
          successImg.style.height = contentHeight + "px";
          successImg.style.width = contentHeight * this.canvasRatio + "px";
        }
      } else {
        let height = maxWidth / this.canvasRatio;
        if (!this.createSuccess) {
          this.myCanvas.setCanvasSize(maxWidth, height);
        }

        if (!this.myCanvasOldHeight) this.myCanvasOldHeight = height;
        this.myCanvas.setCanvasZoom(height / this.myCanvasOldHeight);
        if (successImg) {
          successImg.style.width = maxWidth + "px";
          successImg.style.height = maxWidth / this.canvasRatio + "px";
        }
      }
    },

    initData() {
      dsBridge.call("getCurrentPicture", "", data => {
        if (data) {
          data = typeof data === "string" ? JSON.parse(data) : data;
          this.imgUrl = "data:image/jpg;base64," + data.file;
          var img = new Image();
          img.src = this.imgUrl;
          img.onload = () => {
            console.log("图片尺寸", { width: img.width, height: img.height });
            this.canvasRatio = img.width / img.height;
            this.resetCanvasSizeBefore();
          };
        }
      });
      dsBridge.call("getInfo", "", data => {
        console.log("getInfo", data);
        var type = {}
        if (data) {
          data = typeof data === "string" ? JSON.parse(data) : data;
          type = { VersionType_var: data.versionType, VehicleType_var: data.vehicleType };
          this.vin = data.vin;
          this.themeColor = data.theme;
          store.commit("changeVersionType", data.versionType);
          store.commit("changeVehicleType", data.vehicleType);
        }
        console.log("getInfo-type", type);
        Gio.track(
          {
            ReportedInfo_var: "进入页面",
            ...type
          },
          "AIcreate_Join"
        );
      });

      dsBridge.register("setTheme", data => {
        console.log("setTheme", data);
        if (data) {
          data = typeof data === "string" ? JSON.parse(data) : data;
          this.themeColor = data.theme;
        }
      });
    },
    // backShow
    backConfirm() {
      if (this.isBackClick) return;
      this.isBackClick = true;
      // Gio.track(
      //   {
      //     ReportedInfo_var: "离开页面"
      //   },
      //   "AIcreate_Leave"
      // );
      let timeSpent = (new Date().getTime() - this.nowtTime) / 1000; // 转换为秒

      // 将秒数转换为时分秒格式
      let hours = Math.floor(timeSpent / 3600);
      let minutes = Math.floor((timeSpent % 3600) / 60);
      let seconds = Math.floor(timeSpent % 60);

      // 格式化输出
      let formattedTime = [hours, minutes, seconds]
        .map(num => (num < 10 ? "0" + num : num))
        .join(":");
      console.log(formattedTime);
      Gio.track(
        {
          ReportedInfo_var: "离开页面",
          RequestValue_var: formattedTime
        },
        "AIcreate_Leave"
      );
      dsBridge.call("webGoBack", "", function (v) {
        console.log("webGoBack", v);
        this.backShow = true;
        this.isBackClick = false;
      });
    },
    goBack() {
      if (this.history.length) {
        this.backShow = true;
      } else {
        this.backConfirm();
      }
    }
  },
  destroyed() {
    if (this.timer) clearTimeout(this.timer);
    EventBus.$off();
    this.myCanvas.destroyed();
  }
};
</script>

<style lang="scss" scoped>
@mixin hAuto {
  width: 100vw;
  height: auto;
  aspect-ratio: 16/9;
}

#myCanvas {
  // border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: inset 0px 0px 0px 1px rgba(255, 255, 255, 0.08);
}

.home {
  // background-color: #000;
  background: linear-gradient(180deg,
      #121314 0%,
      #131217 47.6%,
      #121218 63.85%,
      #0f0f12 98.5%);
  color: #fff;
  // height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;
  // padding-top: 24px;
  box-sizing: border-box;

  .navBar {
    @include flex-ac-sb;
    height: 72px;
    line-height: 72px;
    font-size: 16px;
    font-weight: 700;
    box-sizing: content-box;
    position: relative;
    z-index: 20;

    &_left,
    &_right {
      padding: 0 40px;
    }

    &_right {
      opacity: 0.6;
    }

    .navBar_center {
      @include flex-cc;

      .c_btn {
        @include flex-cc;
        width: 53px;
        height: 53px;
        opacity: 0.6;

        .c_btn_img {
          width: 36px;
          height: 36px;
          vertical-align: top;
        }
      }

      .redo {
        transform: rotateY(180deg);
      }
    }
  }

  .content {
    position: relative;
    @include flex_cc;
    overflow: hidden;

    // @include flex-cc;
    .canvasBg {
      background: no-repeat center / 100% 100% rgba(0, 0, 0, 0);

      &.canvasBlur {
        filter: blur(10px);
      }
    }

    .create {
      @include hAuto;
      @include flex-cc;
      position: absolute;
      left: 0;
      top: 50%;
      z-index: 999;
      transform: translateY(-50%);

      // flex-wrap: wrap;
      .create_loading {
        display: flex;
        justify-content: center;
        align-items: center;

        .dot {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #fff;
          margin: 0 4px;
          opacity: 1;
        }

        $im_msgDot_ani_time: 2.1s;

        .dot:nth-child(1) {
          animation: bounce $im_msgDot_ani_time ease-out infinite; //ease-in  linear ease-out
        }

        .dot:nth-child(2) {
          animation: bounce $im_msgDot_ani_time ease-out $im_msgDot_ani_time / 3 infinite;
        }

        .dot:nth-child(3) {
          animation: bounce $im_msgDot_ani_time ease-out $im_msgDot_ani_time / 3 * 2 infinite;
        }

        @keyframes bounce {
          0% {
            transform: translateY(0);
          }

          15% {
            transform: translateY(-0.5em);
          }

          30% {
            transform: translateY(0);
          }

          100% {
            transform: translateY(0);
          }
        }
      }

      .create_text {
        font-size: 20px;
        line-height: 32px;
        text-align: center;
        color: rgba(255, 255, 255, 0.86);
        margin-top: 24px;
      }
    }

    .successImg {
      @include hAuto;
    }
  }

  .content1 {
    // align-items: start !important;
    position: absolute;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 10;
  }

  .foot {
    box-sizing: border-box;
    position: relative;

    // background-color: #131313;
    &.showBottomBar {
      padding-bottom: 34px;
    }

    &.foot1 {
      padding-bottom: 0;
    }

    .createImgAI {
      width: 96px;
      height: 44px;
      background: rgba(255, 255, 255, 0.86);
      border-radius: 49px;
      line-height: 44px;
      text-align: center;
      font-size: 16px;
      color: rgba(10, 10, 10, 1);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -74px;

      // font-family: 'IMSansQH-Regular';
      &:active {
        opacity: 0.6;
      }

      img {
        width: 100%;
        height: 100%;
        vertical-align: top;
      }
    }

    .menuRightDisable {
      opacity: 0.6;
    }

    .menu {
      height: 125px;
      @include flex-jc;
      box-sizing: border-box;
      padding-top: 18px;

      .menu_center {
        @include flex_sb;
        overflow: hidden;
        width: 228px;
        font-size: 14px;
        line-height: 23px;

        .c_btn {
          @include flex_jc;
          flex-wrap: wrap;
          width: 60px;
          height: 67px;
          border-radius: 20px;
          box-sizing: border-box;
          padding: 4px 0;

          img {
            width: 36px;
            height: 36px;
            vertical-align: top;
          }

          div {
            width: 100%;
            flex-shrink: 0;
            text-align: center;
          }
        }

        .c_btn.btnActive {
          background: rgba(255, 255, 255, 0.08);
        }
      }
    }

    .types {
      // box-shadow: 0 0 10px rgba(43, 43, 47, 1);
      overflow: hidden;
      position: absolute;
      left: 50%;
      top: -54px;
      height: 56px;
      background: rgba(43, 43, 47, 1);
      border-radius: 40px;
      transform: translateX(-50%);
      z-index: 999;
      @include flex-ac-sb;
      padding: 0 36px;

      .yuan {
        @include flex-ac-sb;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 2px solid rgba(255, 255, 255, 0.2);
        box-sizing: border-box;
        // margin-right: 36px;
      }

      .yuan:last-child {
        margin-right: 0;
      }

      .widths {
        @include flex-cc;

        div {
          background-color: #fff;
          height: 22px;
          transform: rotate(45deg);
          opacity: 0.6;
        }

        &.active {
          border-color: #fff;

          div {
            opacity: 1;
          }
        }
      }

      .widths:nth-of-type(1) div {
        width: 3px;
        border-radius: 3px;
      }

      .widths:nth-of-type(2) div {
        width: 4px;
        border-radius: 4px;
      }

      .widths:nth-of-type(3) div {
        width: 5px;
        border-radius: 5px;
      }

      .widths:nth-of-type(4) div {
        width: 6px;
        border-radius: 6px;
      }

      .t_xain {
        width: 1px;
        height: 24px;
        background-color: rgba(255, 255, 255, 0.12);
        // margin: 0 36px;
      }

      .colors {
        // margin-left: 36px;
        @include flex-cc;

        img {
          width: 30px;
          height: 30px;
          display: none;
        }

        &.active {
          img {
            display: block;
          }
        }
      }
    }

    .painting {
      width: 85.1%;
      max-width: 1016px;
    }

    .eraser {
      width: 308px;
    }

    .iconWrap {
      width: 85.1%;
      max-width: 1016px;
      height: 128px;
      border-radius: 64px;
      padding: 0;
      top: -126px;

      .iconMask {
        position: absolute;
        top: 0;
        height: 128px;
        width: 1px;
        z-index: 999;
        box-shadow: 0px 0px 70px 70px rgb(43, 43, 47);

        &.before {
          transform: rotate(180deg);
          left: -2px;
        }

        &.after {
          right: -2px;
        }
      }

      &.hideIcon {
        height: 46px;
      }

      .iconList {
        height: 126px;
        overflow-x: scroll;
        //overflow: hidden;
        @include flex-ac;
        padding: 0 30px;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar-track-piece {
          background-color: rgba(0, 0, 0, 0);
          border-left: 1px solid rgba(0, 0, 0, 0);
        }

        &::-webkit-scrollbar {
          width: 5px;
          height: 5px;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          border-radius: 5px;
        }

        &::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.16);
          background-clip: padding-box;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          border-radius: 5px;
          min-height: 28px;
        }

        &::-webkit-scrollbar-thumb:hover {
          background-color: rgba(0, 0, 0, 0.5);
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          border-radius: 5px;
        }

        .iconItem {
          width: 96px;
          height: 96px;
          box-sizing: border-box;
          padding: 8px;
          box-sizing: border-box;
          border-radius: 16px;
          flex-shrink: 0;
          margin-right: 16px;

          img {
            width: 100%;
            height: 100%;
            vertical-align: top;
          }

          &:last-child {
            margin-right: 0;
          }
        }

        .iconActive {
          background: rgba(255, 255, 255, 0.08);
          // border-color: rgba(245, 245, 255, 1);
        }

        .iconDisable {
          opacity: 0.3;
        }

        .iconItem1 {
          height: 0 !important;
          overflow: hidden;
          background: none;
          border: none;
          padding: 0;
        }
      }

      .iconLine {
        position: absolute;
        left: 0;
        bottom: -2px;
        height: 36px;
        width: 100%;
        z-index: 10;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
      }
    }
  }

  .footWrap {
    .createFoot {
      // height: 181px;
      box-sizing: border-box;
      @include flex_jc;
      position: absolute;
      bottom: 74px;
      left: 0;
      width: 100%;
      z-index: 1000;

      .cancelBtn {
        width: 144px;
        height: 56px;
        text-align: center;
        border-radius: 49px;
        line-height: 56px;
        background: rgba(243, 244, 247, 1);
        color: rgba(10, 10, 10, 1);
        margin: 0 auto;
        font-size: 20px;
        font-weight: 400;

        // backdrop-filter: blur(48px)
        &:active {
          opacity: 0.6;
        }
      }

      .btns {
        @include flex_jc;

        .btn {
          @include flex_cc;
          height: 56px;
          width: 178px;
          border-radius: 49px;
          line-height: 56px;
          margin: 0 16px;
          // backdrop-filter: blur(48px);

          img {
            width: 32px;
            height: 32px;
            margin-right: 8px;
          }

          div {
            font-size: 20px;
          }

          &:active {
            opacity: 0.6;
          }
        }

        .btn1 {
          background-color: rgba(255, 255, 255, 0.86);
          color: rgba(10, 10, 10, 1);
        }

        .btn2 {
          background: rgba(56, 58, 76, 1);
        }

        .btn3 {
          img {
            // 定义loading动画
            animation: loading 1s linear infinite;
          }

          @keyframes loading {
            0% {
              transform: rotate(0deg);
            }

            100% {
              transform: rotate(360deg);
            }
          }
        }
      }
    }
  }

  .btnActive {
    opacity: 1 !important;
  }
}

.createHome {
  .norem_navBar {
    padding: 0 !important;
    height: 0 !important;
  }

  .content {
    width: 100vw;
    height: 100vh;
  }
}
</style>
